module.exports = __webpack_public_path__ + "static/img/pure_project_cellar_c_success.0dc3ab3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pure_project_cellar_c_success.jpg
// module id = 303
// module chunks = 1